import React from "react";

export const AddNewPublishedBook = () => {
  return (
    <div className="ml-[5.5rem] mt-8 h-full border-2 border-gray-400 p-4">
      <div className="flex flex-col  gap-5">
        <div className="flex justify-center items-center text-2xl font-bold mb-4">
          Add new published book:
        </div>
        <div>Book Title:
        <input
                  type="text"
                  id="book"
                  placeholder="Enter the book name"
                  className="text-sm p-2 border-2 border-gray-300 rounded-md"
                />
        </div>
        <div>Author name:
        <input
                  type="text"
                  id="author"
                  placeholder="Enter your author name"
                  className="text-sm p-2 border-2 border-gray-300 rounded-md"
                />
        </div>
        <div>Genre:
        <input
                  type="text"
                  id="book"
                  placeholder="Enter the book genre"
                  className="text-sm p-2 border-2 border-gray-300 rounded-md"
                />
        </div>
        <div>Description:
        <input
                  type="text"
                  id="book"
                  placeholder="Enter the book description"
                  className="text-sm p-2 border-2 border-gray-300 rounded-md"
                />
        </div>
        <div>Image Link:
        <input
                  type="text"
                  id="book"
                  placeholder="Enter the book image link"
                  className="text-sm p-2 border-2 border-gray-300 rounded-md"
                />
        </div>
        <div>ISBN(s):
        <input
                  type="text"
                  id="book"
                  placeholder="Enter the book isbn"
                  className="text-sm p-2 border-2 border-gray-300 rounded-md"
                />
        </div>
        <div>Published Date:
        <input
                  type="text"
                  id="book"
                  placeholder="Enter the published date"
                  className="text-sm p-2 border-2 border-gray-300 rounded-md"
                />
        </div>
        <div>Publisher:
        <input
                  type="text"
                  id="book"
                  placeholder="Enter the publisher"
                  className="text-sm p-2 border-2 border-gray-300 rounded-md"
                />
        </div>
        <div className="flex justify-center items-center ">
        <button type="submit" className="bg-maroon text-white rounded-full p-3 hover:bg-lightmaroon">Submit your book</button>
        </div>
      </div>
    </div>
  );
};
